export const modalTokens = {
  'modal-bg': 'var(--dp-color-background)',
  'modal-overlay-bg': 'var(--dp-color-overlay)',
  'modal-border-radius': 'var(--dp-border-radius-xl)',
  'modal-shadow': 'var(--dp-shadow-xl)',
  'modal-width-sm': '400px',
  'modal-width-md': '560px',
  'modal-width-lg': '720px',
  'modal-padding': 'var(--dp-spacing-xl)',
  'modal-header-border': 'var(--dp-color-border)',
  'modal-footer-border': 'var(--dp-color-border)',
  'modal-z-index': '1000',
  'modal-title-font-size': 'var(--dp-font-size-lg)',
} as const;
